var utils = require( './utils' );

var footer_nav = ( function( $ ) {

	var $footer;

	var _init = function() {
		$footer = $( '#footer' );

		$footer.find( '.title' ).on( 'click', _toggle_footer_nav );
	};

	var _toggle_footer_nav = function() {
		var $this = $( this );
		$this.toggleClass( 'open' );
		$this.next().slideToggle();
	};

	if ( utils.viewport_size().width <= 768 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = footer_nav;